import React, { Fragment, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import PrimaryCareProviderForm from '../../../forms/PrimaryCareProviderForm';
import PrimaryCareProviderWithExtraFieldsForm from '../../../forms/PrimaryCareProviderWithExtraFieldsForm';

import {
  selectIsEirVisitTypeCode,
  selectEirVisitTypePCPFormData,
  selectProgressOrganizationId,
} from '../../../../redux/appointmentForm/selectors';
import { appointmentProgressActions } from '../../../../redux/appointmentForm/progress-types';
import {
  getConsiderUsAsYourPCPPayload,
  getInitialPcpFormConsiderUsPcpValue,
  convertPrimaryCareProviderDataToFormOption,
} from '../../../../utils/getPCPDictionaries';

import styles from './index.styl';
import { usePrimaryCareProviderData } from '../../../forms/PrimaryCareProviderWithExtraFieldsForm/hooks/usePrimaryCareProviderData';

function HealthInformationProviderForm() {
  const dispatch = useDispatch();

  const { formatMessage } = useIntl();

  const isEirVisitType = useSelector(selectIsEirVisitTypeCode);

  const eirVisitTypePCPFormData = useSelector(selectEirVisitTypePCPFormData);

  const organizationId = useSelector(selectProgressOrganizationId);

  const providerQuestion = formatMessage({
    id: 'profile.fields.doYouHavePCP',
  });

  const { primaryProviderPreloadedData } = usePrimaryCareProviderData({
    isPaperworkFlow: false,
  });

  const initialValues = useMemo(() => {
    if (!eirVisitTypePCPFormData) return null;

    return {
      pcpProviderAnswer: eirVisitTypePCPFormData.pcpProviderAnswer,
      pcpName: eirVisitTypePCPFormData.pcpName,
      considerUsPcp: getInitialPcpFormConsiderUsPcpValue(
        eirVisitTypePCPFormData.considerUsPcp,
      ),
      pcp: convertPrimaryCareProviderDataToFormOption(
        eirVisitTypePCPFormData.primaryCareProvider,
        eirVisitTypePCPFormData.pcpName,
        formatMessage,
      ),
    };
  }, [eirVisitTypePCPFormData]);

  const handleNext = useCallback(
    formData => {
      if (isEirVisitType) {
        const payload = {
          pcpProviderAnswer: formData.pcpProviderAnswer,
          pcpName: formData.pcpName,
          considerUsPcp: getConsiderUsAsYourPCPPayload(formData),
          primaryCareProvider: formData.pcp,
        };

        dispatch(
          appointmentProgressActions.setPrimaryCareProviderFormData(payload),
        );
      } else {
        dispatch(
          appointmentProgressActions.setHaveCareProviderAnswer({
            pcpProviderAnswer: formData,
          }),
        );
      }

      dispatch(
        appointmentProgressActions.determineNextStepAfterHealthInfoProvider(),
      );
    },
    [isEirVisitType],
  );

  return (
    <Fragment>
      <div className={styles.questions}>{providerQuestion}</div>

      {isEirVisitType ? (
        <PrimaryCareProviderWithExtraFieldsForm
          handleNext={handleNext}
          initialValues={initialValues || primaryProviderPreloadedData}
          organizationId={organizationId}
        />
      ) : (
        <PrimaryCareProviderForm handleNext={handleNext} />
      )}
    </Fragment>
  );
}

export default HealthInformationProviderForm;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentHealthInformationProvider/HealthInformationProviderForm/index.jsx